export const DocumentStatusOption = {
  empty: 'empty',
  pending_review: 'pending_review',
  conditionally_approved: 'conditionally_approved',
  esign_requested: 'esign_requested',
  approve_and_commit: 'approve_and_commit',
  not_required: 'not_required',
  move_to_archived: 'move_to_archived',
  un_archive: 'un_archive',
  rejected: 'rejected',
}

export const EntityType = {
  Guarantor: 'Guarantor',
  Business: 'Business',
}

export const BorrowerType = {
  oc: 'oc',
  epc: 'epc',
  corporate_guarantor: 'corporate_guarantor',
  affiliate: 'affiliate',
}

export const DocumentCategory = {
  business_entity: 'business_entity',
  business_affiliate: 'business_affiliate',
  business_use_of_proceeds: 'business_use_of_proceeds',
  business_financial_and_underwriting: 'business_financial_and_underwriting',
  business_location: 'business_location',
  business_franchise: 'business_franchise',
  business_insurance: 'business_insurance',
  business_sba_forms_and_loan: 'business_sba_forms_and_loan',
  business_bank_search: 'business_bank_search',
  business_funding: 'business_funding',
  business_uncategorized: 'business_uncategorized',
  guarantor_default: 'guarantor_default',
  priority_notes_default: 'priority_notes_default',
}

export const DocumentPhase = {
  main: 'main',
  financials: 'financials',
  closing: 'closing',
}

export const CATEGORY_LABELS = {
  [DocumentCategory.business_entity]: 'Entity',
  [DocumentCategory.business_affiliate]: 'Affiliate',
  [DocumentCategory.business_use_of_proceeds]: 'Use of Proceeds',
  [DocumentCategory.business_financial_and_underwriting]:
    'Financial & Underwriting',
  [DocumentCategory.business_location]: 'Location',
  [DocumentCategory.business_franchise]: 'Franchise',
  [DocumentCategory.business_insurance]: 'Insurance',
  [DocumentCategory.business_sba_forms_and_loan]: 'SBA Forms & Loan',
  [DocumentCategory.business_bank_search]: 'Bank Searches',
  [DocumentCategory.business_funding]: 'Funding Documents',
  [DocumentCategory.business_uncategorized]: 'Additional Documents',
  [DocumentCategory.guarantor_default]: 'Guarantor Default',
  [DocumentCategory.priority_notes_default]: 'Priority Notes',
}

export const PHASE_LABELS = {
  [DocumentPhase.main]: 'Documents',
  [DocumentPhase.financials]: 'Financials',
  [DocumentPhase.closing]: 'Closing',
}

export const EsignVendors = {
  HelloSign: 'hellosign',
  DocuSign: 'docusign',
}

export const DocumentEsignStatuses = {
  signed: 'signed',
  completed: 'completed',
  draft: 'draft',
  sent: 'sent',
  voided: 'voided',
}
